"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bowser = require("bowser");
var BROWSER = {
    IE: 'IE',
    Firefox: 'Firefox',
    Safari: 'Safari',
    Chrome: 'Chrome',
    Unknown: 'Unknown'
}, OS = {
    Windows: 'Windows',
    Mac: 'Mac',
    Linux: 'Linux',
    ChromeOS: 'ChromeOS',
    iOS: 'iOS',
    Android: 'Android',
    WindowsPhone: 'WindowsPhone',
    Unknown: 'Unknown'
};
function getOSVersion() {
    return bowser.osversion ? bowser.osversion.toString() : '';
}
/**
 * This function should consistently return "IE" or "Firefox" if that's the case.
 * It is used in to conditionally execute some logic in feedback directive
 */
function getBrowser() {
    var name = bowser.name;
    if (name === 'Internet Explorer') {
        name = 'IE';
    }
    if (isChromiumEdge()) {
        name = 'Edge';
    }
    return name;
}
function getOS() {
    var os = OS.Unknown;
    if (bowser.mac) {
        os = OS.Mac;
    }
    else if (bowser.windows) {
        os = OS.Windows;
    }
    else if (bowser.chromeos) {
        os = OS.ChromeOS;
    }
    else if (bowser.linux) {
        os = OS.Linux;
    }
    else if (bowser.android) {
        os = OS.Android;
    }
    else if (bowser.ios) {
        os = OS.iOS;
    }
    else if (bowser.windowsphone) {
        os = OS.WindowsPhone;
    }
    return os;
}
function getBrowserVersion() {
    return bowser.version ? bowser.version.toString() : '';
}
function isBrowser(browserString) {
    return getBrowser() === browserString;
}
/* Helper Functions
 *   NOTE: Only add helpers if:
 *   1) You're going to use it more than once, and
 *   2) It provides clearer more readable code !!!
 */
function isIE() {
    return isBrowser(BROWSER.IE);
}
function isChrome() {
    return isBrowser(BROWSER.Chrome);
}
function isMSEdge() {
    return bowser.msedge;
}
function isChromiumEdge() {
    // Ref: https://docs.microsoft.com/en-us/microsoft-edge/web-platform/user-agent-string
    return !!navigator && !!navigator.userAgent
        && navigator.userAgent.indexOf('Edg/') !== -1;
}
function isSafari() {
    return isBrowser(BROWSER.Safari);
}
function isFireFox() {
    return isBrowser(BROWSER.Firefox);
}
function isMobileOrTablet() {
    return bowser.mobile || bowser.tablet;
}
var service = {
    BROWSER: BROWSER,
    getBrowser: getBrowser,
    getBrowserVersion: getBrowserVersion,
    getOSVersion: getOSVersion,
    getOS: getOS,
    isMSEdge: isMSEdge,
    isChromiumEdge: isChromiumEdge,
    isIE: isIE,
    isSafari: isSafari,
    isChrome: isChrome,
    isFireFox: isFireFox,
    isMobileOrTablet: isMobileOrTablet,
    OS: OS
};
exports.default = service;
